const initialState = {
  modifierGroups: [],
  total: 0,
  page: 1,
  totalPages: 0,
};

const modifierGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_MODIFIERS_GROUP":
      return {
        ...state,
        modifierGroups: action.payload.data,
        total: action.payload.total,
        page: action.payload.page,
        totalPages: action.payload.total_pages,
      };

    case "ADD_MODIFIER_GROUP":
      return {
        ...state,
        modifierGroups: [...state.modifierGroups, action.payload],
      };

    case "UPDATE_MODIFIER_GROUP":
      return {
        ...state,
        modifierGroups: state.modifierGroups.map((group) =>
          group.id === action.payload.modifier_group_id
            ? { ...group, ...action.payload }
            : group,
        ),
      };
    case "ASSIGN_PRODUCT_MODIFIER_GROUP":
      return {
        ...state,
        modifierGroups: state.modifierGroups.map((group) =>
          group.id === action.payload.modifier_group_id
            ? { ...group, products: action.payload.productsIds }
            : group,
        ),
      };
    case "BULK_ASSIGN_PRODUCT_MODIFIER_GROUP": {
      const modifierGroupIds = action.payload.modifier_group_ids;
      const productsIds = action.payload.productsIds;
      const operation = action.payload.operation;
      const modifierGroups = state.modifierGroups;
      if (operation === "add")
        return {
          ...state,
          modifierGroups: modifierGroups.map((group) =>
            modifierGroupIds.includes(group.id)
              ? { ...group, products: productsIds }
              : group,
          ),
        };
      else if (operation === "remove") {
        return {
          ...state,
          modifierGroups: modifierGroups.map((group) =>
            modifierGroupIds.includes(group.id)
              ? {
                  ...group,
                  products: group.products.filter(
                    (product) => !productsIds.includes(product),
                  ),
                }
              : group,
          ),
        };
      }
    }

    case "DELETE_MODIFIER_GROUP":
      return {
        ...state,
        modifierGroups: state.modifierGroups.filter(
          (group) => group.id !== action.payload,
        ),
      };
    case "TOGGLE_MODIFIER_GROUP":
      return {
        ...state,
        modifierGroups: state.modifierGroups.map((group) =>
          group.id === action.payload
            ? { ...group, is_active: !group.is_active }
            : group,
        ),
      };
    case "TOGGLE_OPTION_CHOICE": {
      return {
        ...state,
        modifierGroups: state.modifierGroups.map((group) =>
          group.id === action.payload.modifier_group_id
            ? {
                ...group,
                choices: group.choices.map((choice) =>
                  choice.id === action.payload.choice_id
                    ? {
                        ...choice,
                        is_active: !choice.is_active,
                      }
                    : choice,
                ),
              }
            : group,
        ),
      };
    }
    case "DELETE_OPTION_CHOICE": {
      return {
        ...state,
        modifierGroups: state.modifierGroups.map((group) =>
          group.id === action.payload.modifier_group_id
            ? {
                ...group,
                choices: group.choices.filter(
                  (choice) => choice.id !== action.payload.choice_id,
                ),
              }
            : group,
        ),
      };
    }
    case "ADD_OPTION_CHOICE": {
      const modifierGroupId = +action.payload.id;
      const choices = action.payload.choices;
      const newModifierGroups = state.modifierGroups.map((group) =>
        group.id === modifierGroupId
          ? { ...group, choices: [...choices] }
          : group,
      );
      return {
        ...state,
        modifierGroups: newModifierGroups,
      };
    }
    case "EDIT_OPTION_CHOICE": {
      try {
        const { id: modifierGroupId, choices } = action.payload;
        const updates = new Map(choices?.map((choice) => [choice.id, choice]));
        return {
          ...state,
          modifierGroups: state.modifierGroups.map((group) =>
            group.id !== modifierGroupId
              ? group
              : {
                  ...group,
                  choices: group.choices.map((choice) => {
                    const update = updates.get(choice.id);
                    return update ? { ...choice, ...update } : choice;
                  }),
                },
          ),
        };
      } catch (e) {
        console.error(e);
      }
    }

    default:
      return state;
  }
};

export default modifierGroupReducer;
